import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { ArrowRight } from "lucide-react";
import { Whatsapp } from "react-bootstrap-icons";
import { whatsappLink, phoneNo } from "../../../constants/helpers";
import "./WhatsAppHelpSection.css";

const WhatsAppHelpSection = ({ onlyFloating = false }) => {
  const [isVisible, setIsVisible] = useState(true);

  const openWhatsApp = () => {
    window.open(whatsappLink, "_blank");
  };

  const makeCall = () => {
    window.location.href = `tel:${phoneNo}`;
  };

  return (
    <>
      <section
        className={`whatsapp-help-section ${onlyFloating ? "d-none" : ""}`}
      >
        <Container>
          <div className="wh-container">
            <h6 className="wh-subtitle">Need Help Choosing The Right Test?</h6>
            <h2 className="wh-title">
              OUR TEAM WILL GUIDE YOU TO THE RIGHT DIAGNOSTIC SERVICE.
            </h2>

            <div className="wh-actions">
              <button className="wh-btn" onClick={makeCall}>
                Call Now
                <div className="wh-btn-icon">
                  <ArrowRight size={18} />
                </div>
              </button>

              <button className="wh-btn" onClick={openWhatsApp}>
                WhatsApp
                <div className="wh-btn-icon">
                  <ArrowRight size={18} />
                </div>
              </button>
            </div>
          </div>
        </Container>
      </section>

      {/* Persistent Floating WhatsApp Button */}
      {isVisible && onlyFloating && (
        <div className="fixed-whatsapp-btn" onClick={openWhatsApp}>
          <Whatsapp size={32} />
          <button
            className="fixed-whatsapp-close"
            onClick={(e) => {
              e.stopPropagation();
              setIsVisible(false);
            }}
          >
            ×
          </button>
        </div>
      )}
    </>
  );
};

export default WhatsAppHelpSection;
